<template>
  <div class="search-form">
    <el-input v-model="eid" placeholder="ID" style="width:70px;" @change="$emit('change', 'eid')"/>
    <course-select style="width: 120px;" @input="handleCourseChange"></course-select>
    <el-select v-model="level" style="width: 120px;" filterable placeholder="等级" :clearable="true">
      <el-option
        v-for="item in $store.getters.levels"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-input v-model="num" placeholder="序号" style="width:80px;"/>
    <TypeSelect :level="level" v-model="tid"></TypeSelect>
    <el-select v-model="kewen_under" placeholder="课文理解题" style="width:120px;" :clearable="true">
      <el-option value="1" label="是"/>
      <el-option value="0" label="否"/>
    </el-select>
    <el-input v-model="search" placeholder="输入关键字搜索" style="width:200px;"/>
  </div>
</template>

<script>
import TypeSelect from './TypeSelect'
import CourseSelect from "@/components/CourseSelect.vue";

export default {
  name: 'ListSearchForm',
  data () {
    return {
      eid: null,
      level: null,
      num: null,
      tid: null,
      search: null,
      kewen_under: null,
      types: [],
    }
  },
  components: {CourseSelect, TypeSelect },
  watch: {
    level () {
      this.$emit('change', 'level')
    },
    num () {
      this.$emit('change', 'num')
    },
    tid () {
      this.$emit('change', 'tid')
    },
    search () {
      this.$emit('change', 'search')
    },
    kewen_under () {
      this.$emit('change', 'kewen_under')
    }
  },
  methods: {
    handleCourseChange() {
      this.$emit('change', 'course_id')
    }
  }
}
</script>

